<template>
<div>
    <img class="w-100" :src="src" data-toggle="modal" :data-target="'#'+id"/>
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-modal="true" style="display: none;">
        <div class="modal-dialog modal-lg" role="document" style="border-radius:none;">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <img :src="src" class="w-100" />
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import jQuery from 'jquery'
import $ from 'jquery'
import 'jquery-zoom'

export default {
    props: {
        src: {
            required: true,
        }
    },
    computed: {
        id() {
            return 'kt-'+this.randomString(5)
        }
    },
    mounted() {
    },
}
</script>

<style>
</style>